<template>
  <div>
    <SogForm
      ref="_form"
      :validations="_validations"
    >
      <SogFormField v-show="!_value.person.isEmployee()">
        <SogDropDownList
          v-model="_value.person.personType"
          placeholder="Typ"
          :data-source="_lstPersonType"
          :fields="_fields"
          width="220px"
        />
      </SogFormField>
      <div v-show="_value.person.personType==='Legal'">
        <SogFormField>
          <SogTextBox
            v-model="_value.person.name1"
            :placeholder="_legalName1"
            autocomplete="true"
            name="Firma"
            width="220px"
          />
        </SogFormField>
        <SogFormField>
          <SogTextBox
            v-model="_value.person.name2"
            :placeholder="_legalName2"
            autocomplete="true"
            name="Firmenzusatz"
            width="220px"
          />
        </SogFormField>
      </div>
      <div v-show="_value.person.personType==='Natural'">
        <SogFormField>
          <SogRadioButtonGroup
            v-model="_value.person.sex"
            :items="_sexItems"
            name="Sex"
          />
        </SogFormField>
        <SogFormField>
          <SogTextBox
            v-model="_value.person.name2"
            placeholder="Vorname"
            autocomplete="true"
            name="Vorname"
            width="220px"
          />
        </SogFormField>
        <SogFormField>
          <SogTextBox
            v-model="_value.person.name1"
            placeholder="Nachname*"
            autocomplete="true"
            name="Nachname"
            width="220px"
          />
        </SogFormField>
      </div>
    </sogform>
  </div>
</template>

<script setup lang="ts">
import SogForm from "@/shared/ui/SogForm.vue";
import SogFormField from "@/shared/ui/SogFormField.vue";
import SogDropDownList from "@/shared/ui/SogDropDownList.vue";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import SogRadioButtonGroup from "@/shared/ui/SogRadioButtonGroup.vue";
import Person from "@/shared/model/person";
import {computed, reactive, ref, watch} from "vue";
import SogRadioButtonGroupItem from "@/shared/ui/types/SogRadioButtonGroupItem";
import SogFormValidationRule from "@/shared/ui/types/SogFormValidationRule";
import PersonAddressEditComponent from "@/modules/OrganisationStructure/components/PersonAddressEditComponent.vue";


interface Props {
  person: Person,
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(), {
  person: () => new Person()
});

const _lstPersonType = reactive([{id: "Natural", value: "Natürliche Person", icon: "person"}, {
  id: "Legal",
  value: "Juristische Person",
  icon: "business"
}]);
const _form = ref<InstanceType<typeof SogForm> | null>(null)
const _value = reactive({person: props.person})
const _fields = {text: 'value', value: 'id'}
const _sexItems: SogRadioButtonGroupItem[] = [{label: "Herr", value: "M"}, {label: "Frau", value: "W"}]

const _validations: SogFormValidationRule[] = [
  {name: 'Firma', rules: {required: [true, "Geben Sie einen Namen ein."]}},
  {name: 'Nachname', rules: {required: [true, "Geben Sie einen Namen ein."]}},
]

watch(props, () => {
    _value.person = props.person;
  }, {immediate: true}
)
const _legalName1 = computed(() => {
  return props.person.isBranch() ? "Name*" : "Firma*"
})

const _legalName2 = computed(() => {
  return props.person.isBranch() ? "Zusatz" : "Firmenzusatz"
})
const validate = (): boolean => {
  if (_form.value)
    return _form.value.validate();
  return false;
}

const getPerson = (): Person => {
  return _value.person;
}
defineExpose({
  validate, getPerson
})
</script>

<style scoped>

</style>
